import naturalTexture from "../assets/textures/texture-natural.avif";
import blueTexture from "../assets/textures/texture-bluemoon.avif";
import greenTexture from "../assets/textures/texture-green.avif";
import naturalDarkTexture from "../assets/textures/texture-dark-natural.avif";
import terracottaTexture from "../assets/textures/texture-terracotta.avif";
import greyTexture from "../assets/textures/texture-grey.avif";
import blackTexture from "../assets/textures/texture-black.avif";
import whiteTexture from "../assets/textures/texture-white.avif";
import whiteEVATexture from "../assets/textures/texture-EVA-White.avif";
import greyEVATexture from "../assets/textures/texture-EVA-Grey.avif";
import redEVATexture from "../assets/textures/texture-EVA-Red.avif";
import saffronTexture from "../assets/textures/texture-saffron.avif";

const textures = {
  terracotta: terracottaTexture,
  terracottaorange: terracottaTexture,
  white: whiteTexture,
  black: blackTexture,
  blue: blueTexture,
  bluemoon: blueTexture,
  natural: naturalTexture,
  naturaldark: naturalDarkTexture,
  dark: naturalDarkTexture,
  darknatural: naturalDarkTexture,
  smokegrey: greyTexture,
  grey: greyTexture,
  springgreen: greenTexture,
  green: greenTexture,
  saffron: saffronTexture,
  evawhite: whiteEVATexture,
  evagrey: greyEVATexture,
  evared: redEVATexture,
};

export default textures;
